function setActivePage(target, scrollSelector) {
    const page = document.getElementById('page-' + target);
    if (!page) return false;

    document.querySelectorAll('.page').forEach(p => p.classList.remove('active'));
    page.classList.add('active');
    document.body.classList.remove('cart-open');
    const cartDrawer = document.querySelector('.cart-drawer');
    if (cartDrawer) cartDrawer.setAttribute('aria-hidden', 'true');

    document.querySelectorAll('.nav-link').forEach(n => n.classList.remove('active'));
    document.querySelectorAll('.nav-link[data-page="' + target + '"]').forEach(n => n.classList.add('active'));

    document.body.dataset.activePage = target;
    document.body.classList.toggle('is-compact-flow', ['cart', 'account', 'checkout'].includes(target));

    if (scrollSelector) {
      const scrollTarget = document.querySelector('#page-' + target + ' ' + scrollSelector);
      if (scrollTarget) {
        requestAnimationFrame(() => {
          const top = scrollTarget.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({ top, behavior: 'instant' });
        });
      } else {
        window.scrollTo({ top: 0, behavior: 'instant' });
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }

    const navLinks = document.getElementById('nav-links');
    const navToggle = document.getElementById('nav-toggle');
    if (navLinks) {
      navLinks.classList.remove('is-open');
      navLinks.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('nav-open');
    if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
    if (window.EKLAVIV_CLOSE_NAV) window.EKLAVIV_CLOSE_NAV({ restoreFocus: false });
    window.dispatchEvent(new CustomEvent('eklaviv:pagechange', { detail: { target } }));
    return true;
  }

  // Shopify's theme editor can replace section markup after this asset loads.
  // Delegate page navigation so newly rendered controls keep working.
  const PRODUCT_ROUTES = {
    'product-renew': '/products/renew',
    'product-fuel': '/products/fuel',
    'product-cleanser': '/products/cleanser'
  };
  document.addEventListener('click', (e) => {
    const pageControl = e.target.closest('[data-page]');
    if (!pageControl) return;
    e.preventDefault();
    const target = pageControl.getAttribute('data-page');
    if (target === 'home' && window.location.pathname !== '/') { window.location.assign('/'); return; }
    if (PRODUCT_ROUTES[target]) {
      window.location.assign(PRODUCT_ROUTES[target]);
      return;
    }
    setActivePage(target, pageControl.getAttribute('data-scroll-to'));
  });

  (function initRoutePage() {
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    const parentRoute = path.match(/^\/(?:collections\/all\/)?products\/([^/]+)$/);
    const boundRoutine = parentRoute && Array.from(document.querySelectorAll('[data-routine-add]')).find(button => button.getAttribute('data-product-handle') === parentRoute[1]);
    if (boundRoutine) { setActivePage('product-renew', '#renew-routine-bundles'); return; }
    const routes = [
      [/^\/collections\/all$/, 'catalog'],
      [/^\/collections\/all\/products\/(renew-chocolate|eklaviv-renew-chocolate|renew|eklaviv-renew)$/, 'product-renew'],
      [/^\/products\/(renew-chocolate|eklaviv-renew-chocolate|renew|eklaviv-renew)$/, 'product-renew'],
      [/^\/collections\/all\/products\/(fuel|eklaviv-fuel|fuel-nad|eklaviv-fuel-nad|fuel-nad-capsules|eklaviv-fuel-nad-capsules)$/, 'product-fuel'],
      [/^\/products\/(fuel|eklaviv-fuel|fuel-nad|eklaviv-fuel-nad|fuel-nad-capsules|eklaviv-fuel-nad-capsules)$/, 'product-fuel'],
      [/^\/collections\/all\/products\/(cleanser|eklaviv-cleanser|gentle-oat-milk-cleanser|oat-milk-honey-cleanser|oat-milk-and-honey-cleanser|gentle-oat-milk-honey-cleanser)$/, 'product-cleanser'],
      [/^\/products\/(cleanser|eklaviv-cleanser|gentle-oat-milk-cleanser|oat-milk-honey-cleanser|oat-milk-and-honey-cleanser|gentle-oat-milk-honey-cleanser)$/, 'product-cleanser'],
      [/^\/pages\/contact$/, 'contact'],
      [/^\/cart$/, 'cart'],
      [/^\/search$/, 'search'],
      [/^\/account$/, 'account']
    ];
    const match = routes.find(([pattern]) => pattern.test(path));
    if (match) {
      setActivePage(match[1]);
      const anchor = document.getElementById(window.location.hash.slice(1));
      const activePage = document.getElementById('page-' + match[1]);
      if (anchor && activePage && activePage.contains(anchor)) {
        requestAnimationFrame(() => anchor.scrollIntoView({ block: 'start', behavior: 'instant' }));
      }
    }
  })();

  // ============ LOCALIZATION ============
  document.querySelectorAll('.ekl-localization-form select[name="country_code"]').forEach(select => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      if (form) form.submit();
    });
  });

  // ============ SEARCH MODAL ============
  (function initSearchModal() {
    const modal    = document.querySelector('.ekl-search-modal');
    const input    = document.querySelector('#ekl-search-input');
    const grid     = document.getElementById('ekl-search-product-grid');
    const backdrop = document.querySelector('.ekl-modal-backdrop');
    if (!modal) return;

    const openSearch = () => {
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('search-modal-open');
      if (input) { input.value = ''; input.focus(); }
    };
    const closeSearch = () => {
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('search-modal-open');
      if (grid) grid.innerHTML = '';
    };

    document.querySelectorAll('[data-search-open]').forEach(btn => {
      btn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); openSearch(); });
    });

    const closeBtn = modal.querySelector('[data-utility-close]');
    if (closeBtn) closeBtn.addEventListener('click', (e) => { e.stopPropagation(); closeSearch(); });

    if (backdrop) backdrop.addEventListener('click', closeSearch);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSearch(); });

    function renderSearchResults(query) {
      if (!grid) return;
      const q = query.trim();
      if (q === '') { grid.innerHTML = ''; return; }
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function(res) { return res.json(); })
        .then(function(data) {
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            const empty = document.createElement('p');
            empty.className = 'ekl-search-empty';
            empty.textContent = 'No results found for "' + q + '". Try another search.';
            grid.replaceChildren(empty);
            return;
          }
          grid.innerHTML = products.map(function(p) {
            return '<a href="' + p.url + '" class="ekl-search-product">' +
              '<div class="ekl-search-img"><img src="' + p.featured_image.url + '" alt="' + p.title + '"></div>' +
              '<div><div class="ekl-search-title">' + p.title + '</div>' +
              '<div class="ekl-search-price">$' + parseFloat(p.price).toFixed(2) + '</div></div>' +
            '</a>';
          }).join('');
        })
        .catch(function() {
          grid.innerHTML = '<p class="ekl-search-empty">Search unavailable. Please try again.</p>';
        });
    }

    if (input) input.addEventListener('input', function() { renderSearchResults(input.value); });
  })();

  // ============ ACCOUNT POPOVER ============
  (function initAccountPopover() {
    const popover = document.querySelector('.ekl-account-popover');
    const backdrop = document.querySelector('.ekl-modal-backdrop');
    const openers = document.querySelectorAll('[data-account-open]');
    if (!popover || !openers.length) return;

    const open = () => {
      popover.setAttribute('aria-hidden', 'false');
      document.body.classList.add('account-popover-open');
    };
    const close = () => {
      popover.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('account-popover-open');
    };

    openers.forEach(button => button.addEventListener('click', (event) => { event.preventDefault(); open(); }));
    popover.querySelectorAll('[data-utility-close]').forEach(button => { button.addEventListener('click', close); });
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
  })();

  // ============ PRODUCT QUANTITY BUTTONS ============
  document.querySelectorAll('[data-pd-qty-minus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input');
      input.value = Math.max(1, Number(input.value || 1) - 1);
    });
  });
  document.querySelectorAll('[data-pd-qty-plus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input');
      input.value = Number(input.value || 1) + 1;
    });
  });

  // ============ PDP GALLERY ============
  document.querySelectorAll('.pd-gallery').forEach(gallery => {
    const viewport = gallery.querySelector('.pd-gallery-thumbs');
    const thumbTrack = gallery.querySelector('.pd-gallery-thumbs-inner');
    const thumbs = [...gallery.querySelectorAll('.pd-thumb')];
    const mainImage = gallery.querySelector('[data-pd-main] img');
    const galleryWrap = gallery.closest('.ekl-gallery-wrap');
    const caption = galleryWrap && galleryWrap.querySelector('[data-gallery-caption]');
    const description = galleryWrap && galleryWrap.querySelector('[data-gallery-description]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const navigationQueue = [];
    let navigationRunning = false;
    if (!mainImage || !thumbs.length) return;
    const activeIndex = () => Math.max(0, thumbs.findIndex(t => t.classList.contains('is-active')));
    function revealActiveThumb() {
      if (!viewport || !viewport.clientWidth) return;
      const viewportRect = viewport.getBoundingClientRect();
      const thumbRect = thumbs[activeIndex()].getBoundingClientRect();
      let left = viewport.scrollLeft;
      if (thumbRect.left < viewportRect.left) left += thumbRect.left - viewportRect.left;
      else if (thumbRect.right > viewportRect.right) left += thumbRect.right - viewportRect.right;
      else return;
      viewport.scrollTo({left:Math.max(0,left), behavior:reducedMotion.matches ? 'auto' : 'smooth'});
    }
    function updateGalleryCopy(index) {
      const selected = thumbs[index];
      if (caption) {
        caption.replaceChildren(document.createTextNode(`${selected.dataset.imageCaption || ''} `));
        const count = document.createElement('span');
        count.textContent = `${index + 1} / ${thumbs.length}`;
        caption.appendChild(count);
      }
      if (description) description.textContent = selected.dataset.imageDescription || '';
    }
    function moveThumbTrackOne(direction) {
      if (!thumbTrack || !viewport || !direction || thumbTrack.children.length < 2) return Promise.resolve();
      gallery.classList.add('is-thumb-moving');
      gallery.setAttribute('aria-busy','true');
      viewport.scrollLeft = 0;
      const first = thumbTrack.firstElementChild;
      const last = thumbTrack.lastElementChild;
      const style = getComputedStyle(thumbTrack);
      const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      const distance = first.getBoundingClientRect().width + gap;
      if (reducedMotion.matches || typeof thumbTrack.animate !== 'function') {
        if (direction > 0) thumbTrack.appendChild(first);
        else thumbTrack.insertBefore(last, first);
        thumbTrack.style.transform = '';
        gallery.classList.remove('is-thumb-moving');
        gallery.removeAttribute('aria-busy');
        return Promise.resolve();
      }
      if (direction < 0) {
        thumbTrack.insertBefore(last, first);
        thumbTrack.style.transform = `translate3d(-${distance}px,0,0)`;
        void thumbTrack.offsetWidth;
      }
      const from = direction > 0 ? 'translate3d(0,0,0)' : `translate3d(-${distance}px,0,0)`;
      const to = direction > 0 ? `translate3d(-${distance}px,0,0)` : 'translate3d(0,0,0)';
      return new Promise(resolve => {
        const animation = thumbTrack.animate([{transform:from},{transform:to}], {
          duration:220,
          easing:'cubic-bezier(.22,1,.36,1)'
        });
        let settled = false;
        const finish = () => {
          if (settled) return;
          settled = true;
          if (direction > 0) thumbTrack.appendChild(first);
          thumbTrack.style.transform = '';
          gallery.classList.remove('is-thumb-moving');
          gallery.removeAttribute('aria-busy');
          animation.cancel();
          resolve();
        };
        animation.onfinish = finish;
        animation.oncancel = finish;
      });
    }
    function animateMainImage(direction) {
      if (!direction || reducedMotion.matches || typeof mainImage.animate !== 'function') return;
      mainImage.getAnimations().forEach(animation => animation.cancel());
      mainImage.animate([
        {opacity:.3, transform:`translateX(${direction > 0 ? '8%' : '-8%'}) scale(.99)`},
        {opacity:1, transform:'translateX(0) scale(1)'}
      ], {duration:260, easing:'cubic-bezier(.22,1,.36,1)'});
    }
    function activateThumb(index, direction = 0, reveal = false) {
      const selected = thumbs[index];
      const image = selected.querySelector('img');
      thumbs.forEach((thumb,i) => {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-pressed', String(i === index));
        if (i === index) thumb.setAttribute('aria-current','true');
        else thumb.removeAttribute('aria-current');
      });
      mainImage.src = selected.dataset.fullImage || image.src;
      mainImage.alt = image.alt;
      mainImage.dataset.pdImage = String(index);
      updateGalleryCopy(index);
      animateMainImage(direction);
      if (reveal) revealActiveThumb();
    }
    async function drainNavigationQueue() {
      if (navigationRunning) return;
      navigationRunning = true;
      while (navigationQueue.length) {
        const task = navigationQueue.shift();
        if (Number.isInteger(task.index)) {
          const current = activeIndex();
          const direction = task.index === current ? 0 : task.index > current ? 1 : -1;
          activateThumb(task.index, direction, true);
          continue;
        }
        const index = (activeIndex() + task.step + thumbs.length) % thumbs.length;
        activateThumb(index, task.step, false);
        await moveThumbTrackOne(task.step);
      }
      navigationRunning = false;
    }
    function queueNavigation(task) {
      navigationQueue.push(task);
      drainNavigationQueue();
    }
    thumbs.forEach((thumb,index) => thumb.addEventListener('click', () => queueNavigation({index})));
    // The left control moves the strip left and advances to the next image.
    // The right control moves the strip right and selects the previous image.
    for (const [selector,step] of [['[data-pd-arrow="up"]',1],['[data-pd-arrow="down"]',-1]]) {
      const button = gallery.querySelector(selector);
      if (!button) continue;
      button.hidden = thumbs.length <= 1;
      button.addEventListener('click', () => queueNavigation({step}));
    }
    const refresh = () => requestAnimationFrame(() => { if (viewport) viewport.scrollLeft = 0; });
    window.addEventListener('resize', refresh);
    window.addEventListener('eklaviv:pagechange', refresh);
  });

  // ============ CATALOG FILTERS ============
  const catalogFilters = document.querySelectorAll('.catalog-filters [data-filter]');
  const catalogCards = document.querySelectorAll('#page-catalog .product-grid .product-card');
  const catalogCount = document.getElementById('catalog-count');
  const availabilityChecks = document.querySelectorAll('[data-availability-filter]');
  const priceMinInput = document.querySelector('[data-price-min]');
  const priceMaxInput = document.querySelector('[data-price-max]');
  const catalogSortButtons = document.querySelectorAll('#page-catalog [data-sort]');
  const catalogGrid = document.querySelector('#page-catalog .product-grid');
  let activeCatalogCategory = 'all';
  let activeCatalogSort = 'featured';
  catalogCards.forEach((card, index) => { card.dataset.originalOrder = String(index); });

  function getCatalogTitle(card) {
    return card.querySelector('h3') ? card.querySelector('h3').textContent.trim().toLowerCase() : '';
  }

  function sortCatalogCards() {
    if (!catalogGrid) return;
    const sortedCards = [...catalogCards].sort((a, b) => {
      const priceA = Number(a.getAttribute('data-price') || '0');
      const priceB = Number(b.getAttribute('data-price') || '0');
      const titleA = getCatalogTitle(a);
      const titleB = getCatalogTitle(b);
      const orderA = Number(a.dataset.originalOrder || '0');
      const orderB = Number(b.dataset.originalOrder || '0');
      switch (activeCatalogSort) {
        case 'price-low-high': return priceA - priceB || orderA - orderB;
        case 'price-high-low': return priceB - priceA || orderA - orderB;
        case 'alpha-az': return titleA.localeCompare(titleB) || orderA - orderB;
        case 'alpha-za': return titleB.localeCompare(titleA) || orderA - orderB;
        default: return orderA - orderB;
      }
    });
    sortedCards.forEach(card => catalogGrid.appendChild(card));
  }

  function applyCatalogFilters() {
    const selectedAvailability = [...availabilityChecks].filter(i => i.checked).map(i => i.value);
    const min = priceMinInput && priceMinInput.value !== '' ? Number(priceMinInput.value) : null;
    const max = priceMaxInput && priceMaxInput.value !== '' ? Number(priceMaxInput.value) : null;
    let visible = 0;
    sortCatalogCards();
    catalogCards.forEach(card => {
      const categoryMatch = activeCatalogCategory === 'all' || card.getAttribute('data-category') === activeCatalogCategory;
      const availability = card.getAttribute('data-availability') || 'in';
      const availabilityMatch = !selectedAvailability.length || selectedAvailability.includes(availability);
      const price = Number(card.getAttribute('data-price') || '0');
      const priceMatch = (min === null || price >= min) && (max === null || price <= max);
      const match = categoryMatch && availabilityMatch && priceMatch;
      card.style.setProperty('display', match ? 'flex' : 'none', 'important');
      card.hidden = !match;
      if (match) visible++;
    });
    if (catalogCount) catalogCount.textContent = 'Showing ' + visible + ' of ' + catalogCards.length + ' products';
  }

  catalogFilters.forEach(btn => {
    btn.addEventListener('click', () => {
      activeCatalogCategory = btn.getAttribute('data-filter');
      catalogFilters.forEach(b => {
        const active = b === btn;
        b.classList.toggle('active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      applyCatalogFilters();
    });
  });
  availabilityChecks.forEach(input => input.addEventListener('change', applyCatalogFilters));
  [priceMinInput, priceMaxInput].forEach(input => { if (input) input.addEventListener('input', applyCatalogFilters); });
  catalogSortButtons.forEach(button => {
    button.addEventListener('click', () => {
      activeCatalogSort = button.getAttribute('data-sort') || 'featured';
      catalogSortButtons.forEach(btn => btn.classList.toggle('active', btn === button));
      applyCatalogFilters();
      const facet = button.closest('.catalog-facet');
      if (facet) facet.removeAttribute('open');
    });
  });
  document.querySelectorAll('#page-catalog .catalog-facet').forEach(facet => {
    facet.addEventListener('toggle', () => {
      if (facet.open) document.querySelectorAll('#page-catalog .catalog-facet').forEach(other => { if (other !== facet) other.removeAttribute('open'); });
    });
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('#page-catalog .catalog-facet')) {
      document.querySelectorAll('#page-catalog .catalog-facet[open]').forEach(facet => facet.removeAttribute('open'));
    }
  });

  // ============ FAQ ============
  document.querySelectorAll('.faq-list').forEach(list => {
    const items = [...list.querySelectorAll('.faq-item')];
    items.forEach(item => {
      item.addEventListener('toggle', () => {
        if (item.open) items.forEach(other => { if (other !== item) other.open = false; });
      });
    });
  });

  // ============ HERO SLIDESHOW ============
  (function initHeroDotSync() {
    const root = document.getElementById('hero-dots');
    if (!root) return;
    const dots = [...root.querySelectorAll('.ekl-dot')];
    const slides = [...document.querySelectorAll('.ekl-slide')];
    if (!slides.length || dots.length !== slides.length) return;
    const pauseButton = root.querySelector('[data-hero-pause]');
    let current = 0, timer;
    let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function highlight(index) {
      current = index;
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.inert = !active;
      });
    }
    function syncPause() {
      if (!pauseButton) return;
      pauseButton.textContent = paused ? 'Play' : 'Pause';
      pauseButton.setAttribute('aria-label', paused ? 'Resume slideshow' : 'Pause slideshow');
      pauseButton.setAttribute('aria-pressed', paused ? 'true' : 'false');
    }
    function schedule() {
      clearTimeout(timer);
      if (!paused) timer = setTimeout(() => {
        highlight((current + 1) % slides.length);
        schedule();
      }, 8000);
    }
    dots.forEach((dot, index) => dot.addEventListener('click', () => {
      highlight(index);
      schedule();
    }));
    if (pauseButton) pauseButton.addEventListener('click', () => {
      paused = !paused; syncPause(); schedule();
    });
    slides[0].parentElement.addEventListener('focusin', event => {
      if (event.target.closest('.ekl-slide')) { paused = true; syncPause(); schedule(); }
    });
    highlight(0); syncPause(); schedule();
  })();

  // ============ CART / CHECKOUT FLOW ============
  ;(function initCartFlow() {
    'use strict';

    var PRODUCTS = {
      renew: { title: 'EKLAVIV Renew Chocolate', variant: 'Chocolate', price: (window.EKLAVIV_PRICES && window.EKLAVIV_PRICES.renew) ? window.EKLAVIV_PRICES.renew : 39.99, page: 'product-renew', handle: 'eklaviv-renew-chocolate', handles: ['eklaviv-renew-chocolate','renew-chocolate','renew','eklaviv-renew'] },
      fuel:  { title: 'EKLAVIV Fuel', variant: 'NAD+ Capsules', price: (window.EKLAVIV_PRICES && window.EKLAVIV_PRICES.fuel) ? window.EKLAVIV_PRICES.fuel : 54.99, page: 'product-fuel', handle: 'eklaviv-fuel', handles: ['eklaviv-fuel','fuel','fuel-nad','eklaviv-fuel-nad','fuel-nad-capsules','eklaviv-fuel-nad-capsules'] },
      cleanser: { title: 'Oat Milk & Honey Cleanser', variant: 'Oat Milk & Honey', price: (window.EKLAVIV_PRICES && window.EKLAVIV_PRICES.cleanser) ? window.EKLAVIV_PRICES.cleanser : 14.99, page: 'product-cleanser', handle: 'gentle-oat-milk-cleanser', handles: ['gentle-oat-milk-cleanser','cleanser','eklaviv-cleanser','oat-milk-honey-cleanser','oat-milk-and-honey-cleanser','gentle-oat-milk-honey-cleanser'] }
    };

    function asset(name, fallback) { return (window.EKLAVIV_ASSETS && window.EKLAVIV_ASSETS[name]) || fallback; }
    PRODUCTS.renew.image    = asset('Renew_catalog_first.png',    '{{ "Renew_catalog_first.png" | asset_url }}');
    PRODUCTS.fuel.image     = asset('Fuel_catalog_first.png',     '{{ "Fuel_catalog_first.png"  | asset_url }}');
    PRODUCTS.cleanser.image = asset('Cleanser_catalog_first.png', '{{ "Cleanser_catalog_first.png" | asset_url }}');
    var ROUTINES = window.EKLAVIV_ROUTINE_PLANS || {};
    Object.keys(ROUTINES).forEach(function (key) {
      var offer = ROUTINES[key];
      var button = document.querySelector('[data-routine-add="' + key + '"]');
      offer.handle = button && button.getAttribute('data-product-handle') || '';
      offer.image = PRODUCTS.renew.image;
      offer.page = 'product-renew';
      offer.variant = offer.renewQuantity + ' Renew ' + (offer.renewQuantity === 1 ? 'bottle' : 'bottles') + ' + 1 Cleanser bar per bundle';
    });

    var ON_SHOPIFY = window.location.protocol !== 'file:' && typeof window.Shopify !== 'undefined';
    var TIMEOUT_MS = 8000;
    var cartState    = new Map();
    var cartReturnFocus = null;
    var shopifyTotalCents = null;
    var cartCurrency = window.EKLAVIV_CURRENCY || 'USD';
    var shopifyAmountPending = false;
    var variantCache = new Map();
    var _queue       = Promise.resolve();
    var _qtyDebounce = {};

    var badge         = document.querySelector('.cart-badge');
    var drawer        = document.querySelector('.cart-drawer');
    var drawerList    = document.querySelector('[data-cart-drawer-list]');
    var drawerTotal   = document.querySelector('[data-cart-drawer-total]');
    var pageList      = document.querySelector('[data-cart-page-list]');
    var pageTotal     = document.querySelector('[data-cart-page-total]');
    var checkoutList  = document.querySelector('[data-checkout-list]');
    var checkoutTotal = document.querySelector('[data-checkout-total]');

    function enqueueCartAction(fn) {
      _queue = _queue.then(function () {
        setCartBusy(true);
        return Promise.resolve().then(fn)
          .catch(function (err) {
            console.error('[EKLAVIV cart]', err && err.message || err);
            return syncShopifyCart().catch(function () { renderCart(); });
          })
          .finally(function () { setCartBusy(false); });
      }).catch(function (e) { console.warn('[EKLAVIV cart] queue error:', e); setCartBusy(false); });
      return _queue;
    }

    function scheduleQtyChange(key, nextQty) {
      if (_qtyDebounce[key]) clearTimeout(_qtyDebounce[key].timer);
      if (ON_SHOPIFY) shopifyAmountPending = true;
      if (nextQty <= 0) { cartState.delete(key); } else { var item = cartState.get(key); if (item) item.quantity = nextQty; }
      renderCart();
      _qtyDebounce[key] = {
        targetQty: nextQty,
        timer: setTimeout(function () {
          var target = _qtyDebounce[key] ? _qtyDebounce[key].targetQty : nextQty;
          delete _qtyDebounce[key];
          enqueueCartAction(function () { return changeCartLine(key, target); });
        }, 700)
      };
    }

    function setCartBusy(busy) {
      document.querySelectorAll('[data-cart-add],[data-buy-now],[data-routine-add],[data-cart-inc],[data-cart-dec],[data-cart-remove]').forEach(function (btn) {
        btn.disabled = busy || (btn.hasAttribute('data-routine-add') && btn.getAttribute('data-routine-ready') !== 'true');
        btn.setAttribute('aria-busy', busy ? 'true' : 'false');
      });
    }

    function fetchJSON(url, opts, ms) {
      ms = ms || TIMEOUT_MS;
      var ctrl = new AbortController();
      var timer = setTimeout(function () { ctrl.abort(); }, ms);
      return fetch(url, Object.assign({}, opts, { signal: ctrl.signal }))
        .then(function (res) {
          if (!res.ok) throw new Error('[EKLAVIV cart] HTTP ' + res.status + ' — ' + url);
          return res.json();
        })
        .finally(function () { clearTimeout(timer); });
    }

    function cartUrl(path) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
    }

    function fmt(dollars) { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:cartCurrency}).format(Number(dollars || 0)); }

    function escAttr(v) {
      return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
        return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
      });
    }
    function cartCount() { var n = 0; cartState.forEach(function (i) { n += i.quantity * (i.routineKey && ROUTINES[i.routineKey] ? ROUTINES[i.routineKey].renewQuantity + ROUTINES[i.routineKey].cleanserQuantity : 1); }); return n; }
    // Display savings already included in a verified fixed bundle price.
    // Shopify's original line amount is the parent price, not its components' total.
    function nativeRoutineRegularCents(item) {
      var offer = item.routineKey && ROUTINES[item.routineKey];
      var prices = window.EKLAVIV_PRICES;
      if (!offer || cartCurrency !== 'USD' || !prices || !Number.isInteger(item.quantity) || item.quantity < 1) return null;
      if (item.originalLineCents !== offer.totalCents * item.quantity) return null;
      var renewCents = Math.round(Number(prices.renew) * 100);
      var cleanserCents = Math.round(Number(prices.cleanser) * 100);
      var regularCents = renewCents * offer.renewQuantity + cleanserCents * offer.cleanserQuantity;
      if (regularCents !== offer.regularCents) return null;
      return regularCents * item.quantity;
    }
    function lineAmounts(item) {
      if (!ON_SHOPIFY && item.routineKey && ROUTINES[item.routineKey]) {
        var offer = ROUTINES[item.routineKey];
        return {regularCents:offer.regularCents * item.quantity, totalCents:offer.totalCents * item.quantity, savingCents:(offer.regularCents - offer.totalCents) * item.quantity};
      }
      if (!ON_SHOPIFY && window.EKLAVIV_BUNDLE_PRICING) {
        return window.EKLAVIV_BUNDLE_PRICING.quote(item.page.replace('product-', ''), Math.round(item.price * 100), item.quantity, 'USD');
      }
      var totalCents = item.lineTotalCents != null ? item.lineTotalCents : Math.round(item.price * item.quantity * 100);
      var regularCents = item.originalLineCents != null ? item.originalLineCents : totalCents;
      var routineRegularCents = ON_SHOPIFY ? nativeRoutineRegularCents(item) : null;
      if (routineRegularCents != null) regularCents = Math.max(regularCents, routineRegularCents);
      return {totalCents:totalCents, regularCents:regularCents, savingCents:Math.max(0, regularCents - totalCents)};
    }
    function cartTotal() {
      if (ON_SHOPIFY && shopifyTotalCents != null) return shopifyTotalCents / 100;
      var totalCents = 0;
      cartState.forEach(function (item) { totalCents += lineAmounts(item).totalCents; });
      return totalCents / 100;
    }

    function cartSavingsCents() {
      var regularCents = 0;
      cartState.forEach(function (item) { regularCents += lineAmounts(item).regularCents; });
      return Math.max(0, regularCents - Math.round(cartTotal() * 100));
    }

    function renderCartExtras(count, total) {
      var pending = ON_SHOPIFY && shopifyAmountPending;
      var savings = cartSavingsCents();
      document.querySelectorAll('[data-cart-items-label]').forEach(function (el) { el.textContent = count + (count === 1 ? ' item' : ' items'); });
      document.querySelectorAll('[data-cart-regular-total]').forEach(function (el) {
        el.hidden = !count || !savings || pending;
        el.textContent = fmt(total + savings / 100);
      });
      document.querySelectorAll('[data-cart-savings-row]').forEach(function (el) { el.hidden = !count || !savings || pending; });
      document.querySelectorAll('[data-cart-savings-total]').forEach(function (el) { el.textContent = fmt(savings / 100); });
      var message = 'Free shipping on eligible US orders $50+.';
      if (pending) message = 'Updating your cart…';
      else if (count && cartCurrency === 'USD') message = total >= 50 ? 'Free shipping available for eligible US orders.' : fmt(50 - total) + ' away from free shipping on eligible US orders.';
      document.querySelectorAll('[data-cart-shipping-message]').forEach(function (el) { el.textContent = message; });
      document.querySelectorAll('[data-cart-shipping-progress]').forEach(function (el) {
        el.hidden = pending || cartCurrency !== 'USD';
        el.value = Math.max(0, Math.min(50, total));
      });
      document.querySelectorAll('.ekl-cart-shipping-track').forEach(function (el) {
        el.hidden = pending || cartCurrency !== 'USD';
        el.classList.toggle('is-qualified', !pending && count > 0 && total >= 50 && cartCurrency === 'USD');
      });
      var present = new Set();
      cartState.forEach(function (item) {
        present.add(item.page.replace('product-', '') || item.handle);
        if (item.routineKey) { present.add('renew'); present.add('cleanser'); }
      });
      document.querySelectorAll('[data-cart-recommend-product]').forEach(function (el) { el.hidden = present.has(el.getAttribute('data-cart-recommend-product')); });
      document.querySelectorAll('[data-cart-recommendations]').forEach(function (el) { el.hidden = !count || !el.querySelector('[data-cart-recommend-product]:not([hidden])'); });
      document.querySelectorAll('.ekl-cart-summary').forEach(function (el) { el.hidden = !count; });
    }

    function matchProduct(item) {
      var routineKey = Object.keys(ROUTINES).find(function (key) { return ROUTINES[key].handle && ROUTINES[key].handle === (item.handle || item.product_handle); });
      if (routineKey) return Object.assign({routineKey:routineKey}, ROUTINES[routineKey]);
      var raw = [item.handle, item.product_handle, item.product_title, item.title, item.variant_title].filter(Boolean).join(' ').toLowerCase();
      if (/renew|chocolate/.test(raw)) return PRODUCTS.renew;
      if (/fuel|nad/.test(raw)) return PRODUCTS.fuel;
      if (/cleanser|oat|milk|honey/.test(raw)) return PRODUCTS.cleanser;
      return null;
    }

    function normalizeItem(item, index) {
      var matched = matchProduct(item);
      var vt = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      return {
        key: item.key, line: index + 1,
        variantId: Number(item.variant_id || item.id || 0),
        handle: item.handle || (matched && matched.handle) || '',
        title: (matched && matched.title) || item.product_title || item.title || 'EKLAVIV product',
        variant: vt || (matched && matched.variant) || '',
        price: Number(item.final_price != null ? item.final_price : item.price || 0) / 100,
        lineTotalCents: Number(item.final_line_price != null ? item.final_line_price : item.line_price != null ? item.line_price : (item.final_price != null ? item.final_price : item.price || 0) * Number(item.quantity || 0)),
        originalLineCents: Number(item.original_line_price != null ? item.original_line_price : item.line_price != null ? item.line_price : Number(item.price || 0) * Number(item.quantity || 0)),
        image: item.image || (matched && matched.image) || '',
        quantity: Number(item.quantity || 0),
        page: (matched && matched.page) || '',
        routineKey: (matched && matched.routineKey) || ''
      };
    }

    function hydrateCartFromShopifyData(data) {
      cartState.clear();
      shopifyTotalCents = data.total_price != null ? Number(data.total_price) : null;
      cartCurrency = data.currency || cartCurrency;
      shopifyAmountPending = Object.keys(_qtyDebounce).length > 0;
      (data.items || []).forEach(function (item, i) { if (item.key) cartState.set(item.key, normalizeItem(item, i)); });
      renderCart();
      return data;
    }

    function syncShopifyCart() {
      if (!ON_SHOPIFY) { renderCart(); return Promise.resolve({ items: [] }); }
      return fetchJSON(cartUrl('cart.js'), { method: 'GET', headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' }).then(hydrateCartFromShopifyData);
    }

    function resolveVariantId(button, productKey) {
      var fromAttr = Number((button && button.getAttribute('data-variant-id')) || 0);
      if (fromAttr) return Promise.resolve(fromAttr);
      var product = PRODUCTS[productKey];
      if (!product) return Promise.resolve(0);
      if (variantCache.has(productKey)) return Promise.resolve(variantCache.get(productKey));
      if (!ON_SHOPIFY) return Promise.resolve(0);
      var raw = [(button && button.getAttribute('data-product-handle')) || '', (button && button.getAttribute('data-product-handles')) || '', product.handle || '', (product.handles || []).join(',')].join(',');
      var handles = raw.split(',').map(function (h) { return h.trim(); }).filter(function (h) { return h; }).filter(function (h, i, a) { return a.indexOf(h) === i; });
      return handles.reduce(function (chain, handle) {
        return chain.then(function (found) {
          if (found) return found;
          return fetchJSON(cartUrl('products/' + handle + '.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' }, 5000)
            .then(function (data) {
              var variants = data.variants || [];
              var v = variants.find(function (v) { return v.available; }) || variants[0];
              var id = v && Number(v.id);
              if (id) {
                variantCache.set(productKey, id);
                product.handle = handle;
              }
              return id || 0;
            }).catch(function () { return 0; });
        });
      }, Promise.resolve(0));
    }

    function addProduct(productKey, quantity, button) {
      var product = PRODUCTS[productKey];
      if (!product) return Promise.reject(new Error('Unknown product: ' + productKey));
      animateProductToCart(button);
      if (!ON_SHOPIFY) {
        var existing = cartState.get(productKey);
        if (existing) { existing.quantity += quantity; } else { cartState.set(productKey, { key: productKey, line: cartState.size + 1, variantId: 0, handle: product.handle, title: product.title, variant: product.variant, price: product.price, image: product.image, quantity: quantity, page: product.page }); }
        renderCart();
        return Promise.resolve(true);
      }
      return resolveVariantId(button, productKey)
        .then(function (variantId) {
          if (!variantId) throw new Error('No variant ID found for: ' + productKey);
          return fetchJSON(cartUrl('cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }) });
        })
        .then(function () {
          return new Promise(function(resolve) {
            setTimeout(function() { syncShopifyCart().then(resolve).catch(resolve); }, 500);
          });
        });
    }

    function changeCartLine(key, quantity) {
      if (!key) return syncShopifyCart().then(function () { return false; });
      if (!ON_SHOPIFY) {
        if (quantity <= 0) { cartState.delete(key); } else { var item = cartState.get(key); if (item) item.quantity = quantity; }
        renderCart();
        return Promise.resolve(true);
      }
      return fetchJSON(cartUrl('cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: key, quantity: quantity }) })
        .then(hydrateCartFromShopifyData).then(function () { return true; });
    }

    function restorePreviewCart() {
      if (ON_SHOPIFY) return;
      try {
        var saved = JSON.parse(window.sessionStorage.getItem('eklaviv-preview-cart-v7') || '[]');
        if (!Array.isArray(saved)) return;
        saved.forEach(function (entry) {
          if (!entry || typeof entry.key !== 'string' || !Number.isSafeInteger(entry.quantity) || entry.quantity < 1) return;
          var product = Object.prototype.hasOwnProperty.call(PRODUCTS, entry.key) ? PRODUCTS[entry.key] : null;
          var offer = Object.prototype.hasOwnProperty.call(ROUTINES, entry.key) ? ROUTINES[entry.key] : null;
          if (offer) cartState.set(entry.key, {key:entry.key, routineKey:entry.key, quantity:entry.quantity, title:offer.title, variant:offer.variant, price:offer.totalCents / 100, image:offer.image, page:offer.page, handle:'renew'});
          else if (product) cartState.set(entry.key, {key:entry.key, quantity:entry.quantity, title:product.title, variant:product.variant, price:product.price, image:product.image, page:product.page, handle:product.handle});
        });
      } catch (_) { /* Storage may be unavailable; the in-memory preview cart still works. */ }
    }

    function savePreviewCart() {
      if (ON_SHOPIFY) return;
      try { window.sessionStorage.setItem('eklaviv-preview-cart-v7', JSON.stringify(Array.from(cartState, function (entry) { return {key:entry[0], quantity:entry[1].quantity}; }))); } catch (_) {}
    }

    function validateRoutineVariant(offer, button, data) {
      var id = Number(button.getAttribute('data-variant-id'));
      var variant = (data.variants || []).find(function (variant) { return Number(variant.id) === id; });
      if (!id || !variant || !variant.available || Number(variant.price) !== offer.totalCents) throw new Error('This bundle is currently unavailable.');
      return id;
    }

    function addRoutineBundle(key, button) {
      var offer = ROUTINES[key];
      if (!offer || button.getAttribute('data-routine-ready') !== 'true' || cartCurrency !== 'USD') return Promise.reject(new Error('This bundle is currently unavailable.'));
      if (!ON_SHOPIFY) {
        var existing = cartState.get(key);
        if (existing) existing.quantity += 1;
        else cartState.set(key, {key:key, routineKey:key, quantity:1, title:offer.title, variant:offer.variant, price:offer.totalCents / 100, image:offer.image, page:offer.page, handle:'renew'});
        renderCart();
        return Promise.resolve(true);
      }
      return fetchJSON(cartUrl('products/' + offer.handle + '.js'), {headers:{Accept:'application/json'}, credentials:'same-origin', cache:'no-store'})
        .then(function (data) {
          var id = validateRoutineVariant(offer, button, data);
          return fetchJSON(cartUrl('cart/add.js'), {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, credentials:'same-origin', body:JSON.stringify({items:[{id:id, quantity:1}]})});
        }).then(syncShopifyCart);
    }

    function openCart() {
      if (!document.body.classList.contains('cart-open')) cartReturnFocus = document.activeElement;
      renderCart();
      document.body.classList.add('cart-open');
      if (drawer) { drawer.setAttribute('aria-hidden', 'false'); drawer.classList.toggle('is-empty', cartCount() === 0); }
      var scrollBody = drawer && drawer.querySelector('.cart-drawer-body');
      if (scrollBody) scrollBody.scrollTop = 0;
      var closeButton = drawer && drawer.querySelector('.cart-close');
      if (closeButton) closeButton.focus();
    }

    function closeCart() {
      var wasOpen = document.body.classList.contains('cart-open');
      document.body.classList.remove('cart-open');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
      if (wasOpen && cartReturnFocus && cartReturnFocus.isConnected && typeof cartReturnFocus.focus === 'function') cartReturnFocus.focus();
    }

    function emptyHTML() {
      return '<div class="cart-empty cart-empty-premium"><p class="eyebrow">Care that fits your day.</p><h3>A little care starts here.</h3><p>Your cart is empty. Explore Renew, Fuel, and Cleanser to find your everyday essential.</p><button type="button" class="btn btn-green cart-empty-continue" data-cart-empty-continue>Explore the collection</button></div>';
    }

    function lineHTML(item, key) {
      var sk = encodeURIComponent(key);
      var st = escAttr(item.title);
      var amounts = lineAmounts(item);
      var pending = ON_SHOPIFY && shopifyAmountPending;
      var unit = item.routineKey ? 'Bundle' : item.page === 'product-cleanser' ? 'Bar' : /product-(renew|fuel)/.test(item.page) ? 'Bottle' : 'Item';
      var quantityLabel = item.quantity + ' ' + unit + (item.quantity === 1 ? '' : 's');
      var productLink = item.routineKey ? cartUrl('products/' + PRODUCTS.renew.handle) + '#renew-routine-bundles' : cartUrl('products/' + item.handle);
      return '<article class="cart-line cart-line-shopify" data-cart-line="' + sk + '">' +
        '<img src="' + escAttr(item.image || '') + '" alt="' + st + '">' +
        '<div class="cart-line-main"><div class="cart-line-top"><div><h3>' + (item.handle ? '<a class="ekl-cart-product-link" href="' + escAttr(productLink) + '">' + st + '</a>' : st) + '</h3>' +
        (item.variant ? '<p>' + escAttr(item.variant) + '</p>' : '') +
        '<span class="cart-line-unit">' + (amounts.savingCents && ON_SHOPIFY && !item.routineKey ? 'About ' : '') + fmt(item.routineKey && !ON_SHOPIFY ? amounts.regularCents / item.quantity / 100 : item.price) + (amounts.savingCents && !ON_SHOPIFY ? ' <span class="cart-line-unit-note">' + (item.routineKey ? 'per bundle' : 'each') + ' before savings</span>' : ' <span class="cart-line-unit-note">' + (item.routineKey ? 'per bundle' : 'each') + '</span>') + '</span></div>' +
        '<div class="cart-line-price">' + (!pending && amounts.savingCents ? '<s class="ekl-cart-line-original">' + fmt(amounts.regularCents / 100) + '</s>' : '') + '<span>' + (pending ? 'Updating…' : fmt(amounts.totalCents / 100)) + '</span>' + (!pending && amounts.savingCents ? '<div class="cart-line-saving">Saved ' + fmt(amounts.savingCents / 100) + '</div>' : '') + '<small class="ekl-cart-line-quantity">' + quantityLabel + '</small></div></div>' +
        '<div class="cart-line-controls"><div class="cart-qty-stepper" aria-label="Quantity selector">' +
        '<button type="button" data-cart-dec="' + sk + '" aria-label="Decrease quantity">\u2212</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-cart-inc="' + sk + '" aria-label="Increase quantity">+</button></div>' +
        '<button type="button" class="cart-remove" data-cart-remove="' + sk + '" aria-label="Remove">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4h6l.8 1.6H20v1.8H4V5.6h4.2L9 4Zm-2.4 5.2h10.8l-.75 9.35A2.75 2.75 0 0 1 13.9 21h-3.8a2.75 2.75 0 0 1-2.75-2.45L6.6 9.2Zm3.05 2.35.2 6.4h1.35l-.2-6.4H9.65Zm3.15 0-.2 6.4h1.35l.2-6.4H12.8Z"></path></svg>' +
        '</button></div></div></article>';
    }

    function renderList(target, compact) {
      if (!target) return;
      if (!cartState.size) { target.innerHTML = emptyHTML(); return; }
      var html = '';
      cartState.forEach(function (item, key) { html += lineHTML(item, key); });
      target.innerHTML = html;
      if (compact) target.querySelectorAll('.cart-line-controls').forEach(function (el) { el.remove(); });
    }

    function renderCart() {
      var focused = document.activeElement;
      var focusScope = focused && focused.closest ? focused.closest('.ekl-cart-drawer, #page-cart') : null;
      var focusAttribute = focused && ['data-cart-inc','data-cart-dec','data-cart-remove'].find(function (attr) { return focused.hasAttribute && focused.hasAttribute(attr); });
      var focusKey = focusAttribute ? focused.getAttribute(focusAttribute) : null;
      var count = cartCount();
      var total = cartTotal();
      if (badge) badge.setAttribute('data-count', String(count));
      document.querySelectorAll('[data-cart-page-count]').forEach(function (el) { el.textContent = String(count); });
      renderList(drawerList);
      renderList(pageList);
      renderList(checkoutList, true);
      if (drawer) drawer.classList.toggle('is-empty', count === 0);
      var displayedTotal = ON_SHOPIFY && shopifyAmountPending ? 'Updating…' : fmt(total);
      if (drawerTotal) drawerTotal.textContent = displayedTotal;
      if (pageTotal) pageTotal.textContent = displayedTotal;
      if (checkoutTotal) checkoutTotal.textContent = displayedTotal;
      document.querySelectorAll('[data-cart-currency-code]').forEach(function (element) { element.textContent = cartCurrency; });
      renderCartExtras(count, total);
      savePreviewCart();
      if (focusAttribute && focusScope) {
        var replacement = focusScope.querySelector('[' + focusAttribute + '="' + focusKey + '"]') || focusScope.querySelector('.cart-close,[data-cart-empty-continue]');
        if (replacement) replacement.focus({preventScroll:true});
      }
    }

    function animateProductToCart(button) {
      if (!button || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var card = button.closest('.product-card') || button.closest('.pd-hero') || button.closest('.routine-row');
      var sourceImg = card ? card.querySelector('img') : null;
      var target = document.querySelector('[data-cart-open]');
      if (!sourceImg || !target) return;
      var from = sourceImg.getBoundingClientRect();
      var to = target.getBoundingClientRect();
      if (!from.width || !to.width) return;
      var flyer = sourceImg.cloneNode(true);
      var startSize = Math.min(from.width, from.height, 120);
      var endSize = 22;
      flyer.className = 'ekl-fly-cart-image';
      Object.assign(flyer.style, { position: 'fixed', left: (from.left + from.width / 2 - startSize / 2) + 'px', top: (from.top + from.height / 2 - startSize / 2) + 'px', width: startSize + 'px', height: startSize + 'px', objectFit: 'contain', pointerEvents: 'none', zIndex: '9999' });
      document.body.appendChild(flyer);
      var dx = to.left + to.width / 2 - (from.left + from.width / 2);
      var dy = to.top + to.height / 2 - (from.top + from.height / 2);
      var anim = flyer.animate([{ transform: 'translate3d(0,0,0) scale(1)', opacity: 1 }, { transform: 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(' + (endSize / startSize) + ')', opacity: 0.2 }], { duration: 520, easing: 'cubic-bezier(.22,1,.36,1)' });
      anim.onfinish = anim.oncancel = function () { flyer.remove(); };
    }

    function getQtyFromButton(button) {
      var box = button.closest('.pd-buy');
      var inp = box ? box.querySelector('.pd-qty input') : null;
      var quantity = Number(inp ? inp.value : 1); return Number.isFinite(quantity) ? Math.max(1, Math.floor(quantity)) : 1;
    }

    function markCartButtonError(button) {
      if (!button) return;
      var originalContent = button.innerHTML;
      var originalLabel = button.getAttribute('data-original-label') || button.textContent;
      button.setAttribute('data-original-label', originalLabel);
      button.classList.add('is-cart-error');
      button.textContent = 'Couldn’t add this item. Please try again.';
      setTimeout(function () {
        button.classList.remove('is-cart-error');
        button.innerHTML = originalContent;
        var qtyInput = button.closest('.pd-buy') && button.closest('.pd-buy').querySelector('.pd-qty input');
        if (qtyInput) qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        button.disabled = false;
      }, 3500);
    }

    document.addEventListener('click', function (e) {
      var routineButton = e.target.closest('[data-routine-add]');
      if (routineButton) {
        e.preventDefault();
        if (routineButton.disabled || routineButton.classList.contains('is-cart-error')) return;
        enqueueCartAction(function () {
          return addRoutineBundle(routineButton.getAttribute('data-routine-add'), routineButton).then(openCart).catch(function (error) { markCartButtonError(routineButton); throw error; });
        });
        return;
      }
      var addBtn = e.target.closest('[data-cart-add]');
if (addBtn) {
  e.preventDefault();
  if (addBtn.disabled || addBtn.classList.contains('is-cart-error')) return;
  addBtn.disabled = true;
  var pk = addBtn.getAttribute('data-product');
  var qty = getQtyFromButton(addBtn);
  enqueueCartAction(function () {
    return addProduct(pk, qty, addBtn).then(function () {
      openCart();
      addBtn.classList.add('is-added');
      setTimeout(function () { 
        addBtn.classList.remove('is-added'); 
        addBtn.disabled = false;
      }, 1500);
    }).catch(function (error) {
      markCartButtonError(addBtn);
      throw error;
    });
  });
  return;
}

      var buyBtn = e.target.closest('[data-buy-now]');
      if (buyBtn) {
        e.preventDefault();
        enqueueCartAction(function () {
          return addProduct(buyBtn.getAttribute('data-product'), getQtyFromButton(buyBtn), buyBtn)
            .then(function () { window.location.href = cartUrl('checkout'); });
        });
        return;
      }

      var openBtn = e.target.closest('[data-cart-open]');
      if (openBtn) {
        e.preventDefault();
        enqueueCartAction(function () { return syncShopifyCart().then(function () { openCart(); }); });
        return;
      }

      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }

      if (e.target.closest('[data-cart-empty-continue]')) {
        e.preventDefault(); closeCart();
        if (typeof setActivePage === 'function') setActivePage('catalog');
        return;
      }

      var incBtn = e.target.closest('[data-cart-inc]');
      var decBtn = e.target.closest('[data-cart-dec]');
      var remBtn = e.target.closest('[data-cart-remove]');
      if (incBtn || decBtn || remBtn) {
        e.preventDefault(); e.stopPropagation();
        var encoded = (incBtn && incBtn.getAttribute('data-cart-inc')) || (decBtn && decBtn.getAttribute('data-cart-dec')) || (remBtn && remBtn.getAttribute('data-cart-remove')) || '';
        var key;
        try { key = decodeURIComponent(encoded); } catch (_) { key = encoded; }
        if (remBtn) {
          enqueueCartAction(function () { return changeCartLine(key, 0); });
        } else {
          var item = cartState.get(key);
          if (!item) { enqueueCartAction(function () { return syncShopifyCart(); }); return; }
          var nextQty = Math.max(0, item.quantity + (incBtn ? 1 : -1));
          scheduleQtyChange(key, nextQty);
        }
        return;
      }
    });

    document.addEventListener('pointerdown', function (e) {
      if (!document.body.classList.contains('cart-open')) return;
      if (e.target.closest('.cart-drawer') || e.target.closest('[data-cart-open]')) return;
      closeCart();
    });

    document.addEventListener('keydown', function (e) {
      if (!document.body.classList.contains('cart-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); closeCart(); return; }
      if (e.key !== 'Tab' || !drawer) return;
      var controls = Array.from(drawer.querySelectorAll('button:not([disabled]),a[href],input:not([disabled])')).filter(function (el) { return el.getClientRects().length > 0; });
      if (!controls.length) return;
      var first = controls[0], last = controls[controls.length - 1];
      if (!drawer.contains(document.activeElement) || (!e.shiftKey && document.activeElement === last)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    });

    restorePreviewCart();
    syncShopifyCart().catch(function (err) {
      console.warn('[EKLAVIV cart] initial sync failed:', err);
      renderCart();
    });

    window.EKLAVIV_CART_DEBUG = { sync: syncShopifyCart, open: openCart, close: closeCart, cart: cartState };
  })();

  // ============ FOOTER LOCK ============
  (function initZeroGapFooterLock() {
    const setFooterVars = () => {
      const utility = document.querySelector('.utility-bar');
      const header = document.querySelector('.site-header');
      const footer = document.querySelector('.site-footer');
      const headerH = (utility ? utility.offsetHeight : 0) + (header ? header.offsetHeight : 0);
      const footerH = footer ? footer.offsetHeight : 0;
      document.documentElement.style.setProperty('--eklaviv-header-h', headerH + 'px');
      document.documentElement.style.setProperty('--eklaviv-footer-h', footerH + 'px');
      document.documentElement.style.setProperty('--eklaviv-vh', window.innerHeight + 'px');
    };
    setFooterVars();
    window.addEventListener('load', setFooterVars);
    window.addEventListener('resize', setFooterVars);
    window.addEventListener('orientationchange', setFooterVars);
    window.addEventListener('eklaviv:pagechange', () => requestAnimationFrame(setFooterVars));
    setTimeout(setFooterVars, 250);
    setTimeout(setFooterVars, 900);
  })();

  // ============ CATALOG GALLERY ============
  (function initCatalogProductGalleries(){
    const galleries = document.querySelectorAll('#page-catalog [data-gallery]');
    if (!galleries.length) return;
    galleries.forEach(gallery => {
      const images = Array.from(gallery.querySelectorAll('.catalog-gallery-image'));
      const dots = Array.from(gallery.querySelectorAll('.catalog-gallery-dots span'));
      const prev = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      if (!images.length) return;
      let index = Math.max(0, images.findIndex(img => img.classList.contains('active')));
      const show = nextIndex => {
        index = (nextIndex + images.length) % images.length;
        images.forEach((img, i) => img.classList.toggle('active', i === index));
        dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
      };
      prev?.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); show(index - 1); });
      next?.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); show(index + 1); });
      dots.forEach((dot, i) => { dot.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); show(i); }); });
    });
  })();
